import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Loyaltic } from './api-url.constants';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) {}

  private buildHeaders(password: string): { headers: HttpHeaders } {
    return {
      headers: new HttpHeaders({ 'X-Report-Password': password })
    };
  }

  getRegistrations(startDate: string, endDate: string, password: string): Promise<any> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.Registrations}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, this.buildHeaders(password)).toPromise();
  }

  getGames(startDate: string, endDate: string, password: string): Promise<any> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.Games}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, this.buildHeaders(password)).toPromise();
  }

  getMarketingOptins(startDate: string, endDate: string, password: string): Promise<any> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.MarketingOptins}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, this.buildHeaders(password)).toPromise();
  }

  getOptinRate(startDate: string, endDate: string, password: string): Promise<any> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.OptinRate}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, this.buildHeaders(password)).toPromise();
  }

  getRewards(startDate: string, endDate: string, password: string): Promise<any> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.Rewards}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, this.buildHeaders(password)).toPromise();
  }

  exportMarketingOptins(startDate: string, endDate: string, password: string): Promise<Blob> {
    const url = `${environment.baseUrl}${Loyaltic.API.Report.MarketingOptinsExport}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url, {
      ...this.buildHeaders(password),
      responseType: 'blob'
    }).toPromise();
  }
}
